import styled from 'styled-components';

import {
  typography,
  size,
  colors,
  Accordion,
  mediaQueries,
  Container,
} from '@everlywell/leaves';

export const Wrapper = styled.div`
  max-width: 100%;
  padding: 0;
  box-sizing: border-box;
  margin: 0 auto;

  ${mediaQueries.forTabletVerticalUp} {
    max-width: 931px;
    padding: 0 ${size.lg}px;
  }
`;

export const AccordionHeading = styled(Accordion.Heading)`
  padding: ${size.md}px 0 ${size.md}px ${size.lg}px;
  color: ${colors.teal4};
  text-align: left;

  div {
    margin-right: ${size.lg}px;
    margin-left: ${size.xl1}px;
    color: ${colors.teal4};
  }
`;

export const AccordionChild = styled(Accordion.Child)`
  ${typography.bodyText}
  color: ${colors.gray4};
  line-height: 29px;
  padding: 0 ${size.xl4}px ${size.lg}px ${size.lg}px;

  ${mediaQueries.forTabletHorizontalDown} {
    padding: 0 ${size.lg}px ${size.lg}px ${size.lg}px;
    font-size: ${size.md}px;
    line-height: 26px;
  }
`;

export const AccordionWrapper = styled.div`
  > div {
    border-color: ${colors.teal2};
  }
`;

export const SectionHeadline = styled.h1`
  ${typography.h1Text}
  color: ${colors.teal4};
  padding: 0 ${size.lg}px ${size.xl1}px ${size.lg}px;
  border-bottom: 1px solid ${colors.teal2};

  ${mediaQueries.forTabletHorizontalUp} {
    padding: 0 0 ${size.xl2}px 0;
  }
`;
